import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { ReactComponent as GLogo } from "../assets/gear-heart.svg";

const DOCS_URI =
  process.env.REACT_APP_GENEROS_DOCS_URI || "https://docs.generos.io";

function TransitionalFooter() {
  const history = useHistory();
  return (
    <footer>
      <div className="py-12 md:py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="md:flex md:items-center md:justify-between">
            <div className="mb-4 flex justify-start md:order-1 md:mb-0 md:ml-4">
              <a
                href={DOCS_URI}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block text-lilac-700 font-bold hover:text-primary-1 transition duration-150 ease-in-out"
              >
                Learn more
              </a>
            </div>

            <div className="flex flex-col">
              <div
                className="flex items-center"
                onClick={() => history.push("/")}
              >
                <Link to="/" className="inline-block" aria-label="Generos">
                  <GLogo className="w-12 fill-current text-primary-1 mr-3" />
                </Link>
                <div className="text-gray-400 text-sm mr-4">
                  {`© ${moment().format(
                    "YYYY"
                  )} Generos, Inc. All Rights Reserved`}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default TransitionalFooter;
